import type { Input } from '@builder.io/sdk';

const tableFields = [
  {
    name: 'heading',
    type: 'text',
    helperText: 'Copy for the image',
  },
  {
    name: 'rows',
    type: 'list',
    helperText: 'First row will be the header',
    subFields: [
      {
        name: 'columns',
        type: 'list',
        subFields: [
          {
            name: 'content',
            type: 'text',
            helperText: 'Content for the cell and Header content',
          },
        ],
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

export type TableProps = GenerateBuilder<typeof tableFields>;

const tableBuilderConfig = {
  name: 'HCI Table Component',
  inputs: tableFields,
};

export default tableBuilderConfig;
